import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import sliderrr from "assets/img/sliderrr.jpg";
import shakehand from "assets/img/shakehand.png";
import target from "assets/img/target.png";
import award from "assets/img/award.png";
import partner from "assets/img/partner.png";
import partner1 from "assets/img/partner (1).png";
import feedback from "assets/img/feedback.png";
import benefit from "assets/img/benefit.png";

// french translatin import statements start
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";
// french translatin import statements end

const BannerSlider = () => {
  // french translatin import statements
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();
  // french translatin import statements end

  const sections = useRef([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const content = entry.target.querySelector(".content");
            if (content) {
              content.classList.add("animate-up");
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  const settings = {
    dots: false,
    infinite: true,
    centerPadding: "1rem",
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 8000, // Adjusted to match the slider speed
    pauseOnHover: false,
    beforeChange: (current, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const contentDivs = document.querySelectorAll(".slide-item .content");
    contentDivs.forEach((div) => {
      if (div) {
        div.classList.remove("animate-up");
      }
    });

    setTimeout(() => {
      contentDivs.forEach((div, index) => {
        if (div && index === currentSlide) {
          div.classList.add("animate-up");
        }
      });
    }, 2000); // Delay the animation to ensure it takes place after the slide transition
  }, [currentSlide]);

  /* scrolldown slowly coming animation start */

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target); // Stop observing the section once it's animated
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 2000);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  /* scrolldown slowly coming animation end */

  return (
    <section
      ref={(el) => sections.current.push(el)}
      className="animate-on-scroll bg-white md:mt-0 mt-17"
    >
      <div className="overflow-hidden">
        <Slider {...settings} className="">
          {[sliderrr].map((slide, index) => (
            <div
              key={index}
              ref={(el) => el && sections.current.push(el)}
              className="slide-item"
            >
              <div
                className="xl:h-650 lg:h-550 md:h-431 h-220 grid xl:grid-cols-1 xl:gap-4 md:grid-cols-1"
                style={{
                  backgroundSize: "cover",
                }}
              >
                <video
                  className="absolute object-cover bgggg"
                  src="/bannerone.mp4"
                  autoPlay
                  loop
                  muted
                ></video>
                <div className="bgggg">
                  <div className="bg-banner xl:pt-12 lg:pt-20 md:pt-8 pt-8 mx-auto flex flex-wrap relative">
                    <div
                      className={`w-full center-items md:w-12/12 lg:w-12/12 xl:w-12/12 content ${
                        index === currentSlide ? "animate-up" : ""
                      }`}
                    >
                      <h1 className="w-9/12 px-4 pt-2 text-white uppercase xl:text-banner lg:text-4xl md:text-3xl text-2xl banner-font font-bold">
                        {t("bannercontent1")}
                      </h1>
                      <h1 className="w-9/12 px-4 pt-2 text-white uppercase xl:text-banner lg:text-4xl md:text-3xl text-2xl banner-font font-bold">
                        {t("bannercontent2")}
                      </h1>
                      <p className="w-8/12 text-white uppercase xl:text-xl text-sm banner-font xl:pt-4 pt-3 md:pb-4 pb-8">
                        {t("bannercontent3")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div
        ref={(el) => el && sections.current.push(el)}
        style={{
          // backgroundColor: "#f5f5f5",
          backgroundColor: "rgb(0 149 207 / 7%)",
          backgroundSize: "cover",
        }}
        className="animate-on-scroll xl:-mt-28 lg:-mt-28 md:-mt-24 -mt-12 xl:block lg:block md:block hidden"
      >
        <div className="container mx-auto px-12 xl:px-28 lg:px-12 xl:pb-16 md:px-4 lg:py-16 py-6">
          <div className="grid relative md:grid-cols-3 gap-4 grid-cols-1">
            <div className="bg-white top-right action shadow-xl center-items xl:px-8 lg:px-8 md:px-4 px-8 pt-8 xl:pt-12 lg:pt-8 md:pt-8">
              <img
                alt="Your browser doe not supoort this image"
                src={partner}
                className="xl:w-20 lg:w-20 md:w-16 w-16 logorotate"
              />
              <p className="xl:pt-6 lg:pt-5 pt-3 lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                {t("home.headblack1")}{" "}
                <span className="text-redd"> {t("home.headred1")}</span>
              </p>
              <p className="pt-2 xl:pb-12 xl:px-0 lg:px-2 md:pb-8 pb-8 text-center border-b-blue xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                {t("home.content1")}
              </p>
            </div>

            <div className="bg-dark top-right action shadow-xl center-items xl:px-8 lg:px-8 md:px-4 px-8 pt-8 xl:pt-12 lg:pt-8 md:pt-8">
              <img
                alt="Your browser doe not supoort this image"
                src={benefit}
                className="xl:w-20 lg:w-20 md:w-16 w-16 logorotate rounded-xl"
              />
              <p className="xl:pt-6 lg:pt-5 pt-3 lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-white font-medium text-center">
                {t("home.headblack2")}{" "}
                <span className="text-white">{t("home.headred2")} </span>
              </p>
              <p className="pt-2 xl:pb-12 md:pb-8 pb-8 text-center xl:text-para text-base text-white leading-relaxed headlineheight banner-font">
                {t("home.content2")}
              </p>
            </div>

            <div className="bg-white top-right action shadow-xl center-items xl:px-8 lg:px-8 md:px-4 px-8 pt-8 xl:pt-12 lg:pt-8 md:pt-8">
              <img
                alt="Your browser doesnot support this image"
                src={feedback}
                className="xl:w-20 lg:w-20 md:w-16 w-16 logorotate"
              />
              <p className="xl:pt-6 lg:pt-5 pt-3 lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                {t("home.headblack3")}{" "}
                <span className="text-redd">{t("home.headred3")} </span>
              </p>
              <p className="pt-2 text-center xl:px-0 lg:px-2 xl:pb-12 md:pb-8 pb-8 xl:text-para border-b-blue text-base  text-gray leading-relaxed headlineheight banner-font">
                {t("home.content3")}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        ref={(el) => el && sections.current.push(el)}
        className="animate-on-scroll xl:-mt-28 lg:-mt-28 md:-mt-24 -mt-4 px-4 xl:hidden lg:hidden md:hidden block"
      >
        <div className="container mx-auto p-8 bg-white overflow-hidden">
          <div className="grid-grid-cols-1">
            <div className="flex">
              <div className="">
                <img src={partner} className="w-64" />
              </div>
              <div className="text-left pl-4">
                <p className="xl:pt-6 lg:pt-5 pt-3 lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium">
                  {t("home.headblack1")}{" "}
                  <span className="text-redd"> {t("home.headred1")} ﹥</span>
                </p>
                <p className="pt-2 xl:pb-12 xl:px-0 lg:px-2 md:pb-8 pb-8 xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                  {t("home.content1")}
                </p>
              </div>
            </div>
            <div className="flex">
              <div className="">
                <img src={benefit} className="bg-dark-blue w-64 rounded-md" />
              </div>
              <div className="text-left pl-6">
                <p className="xl:pt-6 lg:pt-5 pt-0 lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium">
                  {t("home.headblack2")}{" "}
                  <span className="text-redd">{t("home.headred2")} ﹥</span>
                </p>
                <p className="pt-2 xl:pb-12 xl:px-0 lg:px-2 md:pb-8 pb-8 xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                  {t("home.content2")}
                </p>
              </div>
            </div>
            <div className="flex">
              <div className="">
                <img src={feedback} className="w-64" />
              </div>
              <div className="text-left pl-3">
                <p className="xl:pt-6 lg:pt-5 pt-1 lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium">
                  {t("home.headblack3")}{" "}
                  <span className="text-redd">{t("home.headred3")} ﹥</span>
                </p>
                <p className="pt-2 xl:pb-12 xl:px-0 lg:px-2 md:pb-8 pb-4 xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                  {t("home.content3")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerSlider;
